import script from "./SidebarNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarNav.vue?vue&type=script&setup=true&lang=js"

import "./SidebarNav.vue?vue&type=style&index=0&id=1e8d9868&lang=css"

const __exports__ = script;

export default __exports__